import { useTranslation } from 'react-i18next';
import { memo } from 'react';
import { ActionModal } from 'components/mui/common/ActionModal';
import { Typography } from '@mui/material';

import type { CHANGE_BEHAVIOR_OPTION } from 'types/enums';

interface Props {
  onClose: () => void;
  onConfirm: () => void;
  open: boolean;
  behaviorType: CHANGE_BEHAVIOR_OPTION;
  isSubmitting?: boolean;
}

export const ConditionRunModal = memo(({ onClose, onConfirm, open, behaviorType, isSubmitting }: Props) => {
  const { t } = useTranslation();
  return (
    <ActionModal
      maxWidth="xs"
      open={open}
      onClose={onClose}
      onSubmit={onConfirm}
      onCancel={onClose}
      title={t('flow.modulesAndAgendas.form.confirmAction')}
      submitText={t('flow.modulesAndAgendas.form.runAction')}
      isSubmitting={isSubmitting}
      disableBackdropClick={isSubmitting}>
      <Typography>{t(`flow.modulesAndAgendas.form.${behaviorType}`)}</Typography>
    </ActionModal>
  );
});
